import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-belair-test-payment',
  templateUrl: './belair-test-payment.component.html',
  styleUrls: ['./belair-test-payment.component.scss']
})
export class BelairTestPaymentComponent implements OnInit {
  BELAIR_TEST_PG!: FormGroup;
  @Input() item: any;
  constructor(private fb: FormBuilder) { }

  ngOnInit(): void { 
    console.log('Initial item:', this.item);
    this.BELAIR_TEST_PG = this.fb.group({
      test_payment_type: 'TEST',
      test_currency:  'INR', // this.currency__,
      test_payOption: this.item?.options[0]?.index, // this.item[0].index,
    });
  }

  getBELAIR_TEST_PGFormValue(): any {
    if (this.BELAIR_TEST_PG.invalid) {
      this.BELAIR_TEST_PG.markAllAsTouched();
      return null;
    }
    return this.BELAIR_TEST_PG.value;
  }
}
